// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"65":"b94856fb","95":"0fb1925f","244":"a090b236","399":"993d37f9","511":"6121fd07","779":"f73521e5"}[chunkId] + ".css";
};